import { Button, Typography, useTheme, Container } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router';
import Image from '../../../components/image';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { translateKey } from 'src/locales/translate';


export default function CampaignPaymentConfirmation() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { organizationId } = useParams<{ organizationId: string }>();

  const onButtonClick = () => {
    navigate(
      PATH_DASHBOARD.general.organizations.campaigns(organizationId || ''),
    );
  };

  return (
    <>
      <Helmet>
        <title>{translateKey("hardcoded.platnosc_potwierdzona_vetsi")}</title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack
          sx={{
            height: '100vh',
            minHeight: '80vh',
            alignItems: 'center',
            px: { xs: 3, sm: 3, md: 3, lg: 0, xl: 0 },
          }}
        >
          <Image
            disabledEffect
            visibleByDefault
            alt="payment-confirmation"
            src="/assets/illustrations/laptop-paw-blue.svg"
            sx={{
              maxWidth: { xs: 280, sm: 320, md: 360 },
            }}
          />
          <Stack
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              maxWidth: 572,
            }}
          >
            <Box>
              <Typography
                variant="h3"
                sx={{ color: theme.palette.success.main, textAlign: 'center' }}
              >
                Sukces!
              </Typography>
              <Typography variant="h3" sx={{ textAlign: 'center' }}>{translateKey("hardcoded.platnosc_zostala_przyjeta")}</Typography>
            </Box>
            <Typography
              variant="h6"
              sx={{ textAlign: 'center', color: 'text.secondary' }}
            >{translateKey("hardcoded.twoja_kampania_google_ads_zostanie_uruchomiona_wkrotce_mozesz")}</Typography>
          </Stack>
          <Stack sx={{ gap: 3, alignItems: 'center', mt: 4 }}>
            <Button variant="contained" size="large" onClick={onButtonClick}>{translateKey("hardcoded.przejdz_do_kampanii")}</Button>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}
